export type OffsetType = {
  left: number
  top: number
}

export type SizeType = {
  width: number
  height: number
}

export type PaddingType = {
  top?: number | null
  left?: number | null
  right?: number | null
  bottom?: number | null
}

export type RectType = OffsetType & SizeType
export type FullRectType = RectType & {bottom: number; right: number}

export function intersectRect(a: RectType, b: RectType): RectType {
  const left = Math.max(a.left, b.left)
  const top = Math.max(a.top, b.top)
  const right = Math.min(a.left + a.width, b.left + b.width)
  const bottom = Math.min(a.top + a.height, b.top + b.height)
  return {
    left,
    top,
    width: right - left,
    height: bottom - top,
  }
}

export function offsetRect(rect: RectType, {left, top}: OffsetType): RectType {
  return {
    left: rect.left + left,
    top: rect.top + top,
    width: rect.width,
    height: rect.height,
  }
}

export function padRect(
  rect: RectType,
  padding: PaddingType | number
): RectType {
  if (!padding) return rect
  if (typeof padding === 'object') {
    return {
      left: rect.left + (padding.left || 0),
      top: rect.top + (padding.top || 0),
      width: Math.max(
        0,
        rect.width - (padding.left || 0) - (padding.right || 0)
      ),
      height: Math.max(
        0,
        rect.height - (padding.top || 0) - (padding.bottom || 0)
      ),
    }
  } else if (typeof padding === 'number') {
    return {
      left: rect.left + padding,
      top: rect.top + padding,
      width: Math.max(0, rect.width - 2 * padding),
      height: Math.max(0, rect.height - 2 * padding),
    }
  }
  return rect
}
